import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import Config from '../config/config';

class ProductIntroductionGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gallerySwiper: null,
      thumbnailSwiper: null,
    };

    this.galleryRef = this.galleryRef.bind(this);
    this.thumbRef = this.thumbRef.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.gallerySwiper && nextState.thumbnailSwiper) {
      const { gallerySwiper, thumbnailSwiper } = nextState;

      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }

  galleryRef(ref) {
    if (ref) this.setState({ gallerySwiper: ref.swiper });
  }

  thumbRef(ref) {
    if (ref) this.setState({ thumbnailSwiper: ref.swiper });
  }

  render() {
    const { product } = this.props;
    const gallerySwiperParams = {
      spaceBetween: 20,
      shouldSwiperUpdate: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    const thumbnailSwiperParams = {
      spaceBetween: 20,
      centeredSlides: true,
      slidesPerView: 5,
      touchRatio: 0.2,
      slideToClickedSlide: true,
      shouldSwiperUpdate: true,
    };

    return (
      <React.Fragment>
        <Swiper
          containerClass="swiper-container swiper--gallery"
          {...gallerySwiperParams}
          ref={this.galleryRef}
        >
          {product.image.map((elem, idx) => (
            <div key={`image${idx}`}>
              <figure className="image is-square">
                <div
                  style={{ backgroundImage: `url(${Config.apiUrl}${elem.url})` }}
                  className="slide-product-image"
                />
              </figure>
            </div>
          ))}
        </Swiper>
        <Swiper
          containerClass="swiper-container swiper--thumbnail"
          {...thumbnailSwiperParams}
          ref={this.thumbRef}
        >
          {product.image.map((elem, idx) => (
            <div key={`image${idx}`} className="image--thumbnail-wrapper">
              <figure className="image is-square">
                <div
                  style={{ backgroundImage: `url(${Config.apiUrl}${elem.url})` }}
                  className="slide-product-image"
                />
              </figure>
            </div>
          ))}
        </Swiper>
      </React.Fragment>
    );
  }
}

ProductIntroductionGallery.propTypes = {
  product: PropTypes.shape({
    image: PropTypes.arrayOf(PropTypes.object),
  }),
};

ProductIntroductionGallery.defaultProps = {
  product: {
    image: [],
  },
};

export default ProductIntroductionGallery;



// WEBPACK FOOTER //
// ./src/components/ProductIntroductionGallery.js